import React from "react";
import Home1 from "./Home1";


const HomePrivate = () => {
    return (
        <>
            <Home1 />
        </>
    );
};

export default HomePrivate

